export default __webpack_public_path__ + "static/play-button-88c37f6503dbbb46db1108c2b3a52d03.webm";